const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%2C%20science%20fiction%20aesthetic%2C%20futuristic%20cityscape%20at%20night%2C%20cinematic%20color%20grading%20with%20warm%20highlights%2C%20movie%20poster%20style%2C%20epic%20scale%2C%20no%20text%2C%20dark%20rich%20atmosphere&width=800&height=450&seq=media-trailer-01&orientation=landscape',
    title: '《流浪地球3》震撼预告',
    tag: '科幻巨制',
    duration: '02:35',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%2C%20historical%20costume%20aesthetic%2C%20warm%20candlelight%20illuminating%20ornate%20interior%2C%20cinematic%20composition%2C%20rich%20textures%2C%20film%20noir%20color%20palette%2C%20no%20people%20visible%2C%20mysterious%20atmosphere&width=800&height=450&seq=media-trailer-02&orientation=landscape',
    title: '《庆余年3》剧情前瞻',
    tag: '古装权谋',
    duration: '03:12',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20epic%20battle%20scene%2C%20Japanese%20animation%20aesthetic%2C%20warm%20golden%20energy%20effects%2C%20dramatic%20composition%2C%20dark%20background%20with%20vibrant%20color%20accents%2C%20cinematic%20atmosphere%2C%20no%20text&width=800&height=450&seq=media-trailer-03&orientation=landscape',
    title: '《鬼灭之刃》最终章PV',
    tag: '热血动漫',
    duration: '01:58',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20film%20scene%2C%20warm%20evening%20city%20lights%2C%20cinematic%20shallow%20depth%20of%20field%2C%20golden%20hour%20aesthetic%2C%20emotional%20atmosphere%2C%20film%20poster%20style%20composition%2C%20rich%20color%20grading%2C%20no%20text&width=800&height=450&seq=media-trailer-04&orientation=landscape',
    title: '《想见你》特别篇预告',
    tag: '爱情悬疑',
    duration: '04:05',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Stage%20performance%20with%20dramatic%20spotlight%2C%20variety%20show%20aesthetic%2C%20dynamic%20colorful%20lighting%2C%20concert%20atmosphere%2C%20warm%20and%20vibrant%20stage%20design%2C%20cinematic%20wide%20shot%2C%20energetic%20mood%2C%20no%20people%20faces%20visible&width=800&height=450&seq=media-trailer-05&orientation=landscape',
    title: '《乘风破浪》公演直拍',
    tag: '综艺热播',
    duration: '05:20',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            最新影片预告与精彩片段，提前感受大片魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <div className="w-full h-[180px] md:h-[200px]">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-xs px-2 py-1 rounded-full bg-background-50/80 text-foreground-700 font-medium backdrop-blur-sm whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs px-2 py-1 rounded-full bg-background-50/60 text-foreground-500 backdrop-blur-sm whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>{item.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 line-clamp-1">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}